(function () {
  const THRESHOLD = 50.00;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function updatePromoButtons() {
    const cart = await getCart();
    const subtotal = cart.total_price / 100;
    const cartItems = cart.items.map(i => i.variant_id);

    document.querySelectorAll('.promo-atc-btn').forEach(btn => {
      const variantId = parseInt(btn.dataset.variantId);
      const alreadyInCart = cartItems.includes(variantId);
      const notice = btn.closest('.promo-atc-wrapper').querySelector('.promo-atc-notice');

      if (alreadyInCart) {
        btn.disabled = true;
        btn.querySelector('.promo-atc-label').textContent = '✓ Ya añadido';
        btn.classList.add('promo-atc-btn--added');
        notice.style.display = 'none';
      } else if (subtotal >= THRESHOLD) {
        btn.disabled = false;
        btn.querySelector('.promo-atc-label').textContent = 'Añadir al carrito';
        notice.style.display = 'none';
      } else {
        btn.disabled = true;
        btn.querySelector('.promo-atc-label').textContent = 'Añadir al carrito';
        notice.style.display = 'block';
      }
    });
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.promo-atc-btn');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    btn.disabled = true;
    btn.querySelector('.promo-atc-label').textContent = 'Añadiendo...';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('Error añadiendo al carrito:', err);
    }

    await updatePromoButtons();
  });

  document.addEventListener('cart:refresh', updatePromoButtons);
  updatePromoButtons();
})();
